namespace SolovisGateway.Admin.Organizations {

    export interface OrgAddConnectionDialogOptions extends SupportContactOptions {
        organizationId: number;
        connectionAddedCallback?: () => void;
    }

    export class OrgAddConnectionDialog {

        private _options: OrgAddConnectionDialogOptions;
        constructor(options: OrgAddConnectionDialogOptions) {
            this._options = options;
        }

        private _createDialog(body: JQuery, buttons: Array<any>) {
            return new (Solovis as any).UI.Dialog({
                container: body,
                title: "Add New Connection",
                modal: true,
                autoOpen: true,
                center: true,
                destroyOnClose: true,
                actions: ["Close"],
                minWidth: 200,
                maxWidth: 500,
                buttons: buttons
            });
        }

        public show() {
            var self = this;
            var dialog = null;

            var body = $("<div>")
                .append($("<p>").text("Do you want to set up a new connection for this organization?"));

            dialog = this._createDialog(body, [
                {
                    label: "Next",
                    click: function () {
                        dialog.close();
                        self._initiateConnectionSetup();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        dialog.close();
                    }
                }
            ]);
        }

        private async _initiateConnectionSetup() {
            var self = this;
            var waitPanel = new Solovis.UI.ModalWaitPanel({});
            waitPanel.show();

            try {
                var response = await Solovis.Rpc.invoke("~/Organization/AddConnectionSetup", {
                    organizationId: self._options.organizationId
                });
                waitPanel.hide();

                var onClose = function () {
                    if (self._options.connectionAddedCallback) {
                        self._options.connectionAddedCallback();
                    }
                };

                if (response.result.ticketGenerationFailed) {
                    var pendingDialog = new OrgConnectionSetupPendingDialog({
                        connectionName: response.result.connectionName,
                        supportContactText: self._options.supportContactText,
                        supportContactLink: self._options.supportContactLink,
                        onClose: onClose
                    });
                    pendingDialog.show();
                } else {
                    var setupLinkDialog = new OrgConfigureConnectionLinkDialog({
                        setupLink: response.result.setupLink,
                        onClose: onClose
                    });
                    setupLinkDialog.show();
                }
            } catch (e) {
                waitPanel.hide();
                self.showError();
            }
        }

        public showError() {
            var errorDialog = null;

            var body = $("<div>");

            var errorBanner = $("<div>").css({
                "background-color": "#f2dede",
                "border": "1px solid #ebccd1",
                "color": "#a94442",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px"
            });
            errorBanner.append($("<span>").text("We could not start the new connection setup. Please try again in a little while. "));
            SsoConnectionStatusUi.appendSupportContactLine(errorBanner, this._options, "If the problem continues, ", ".");
            body.append(errorBanner);

            body.append($("<p>").text("No connection was created."));

            errorDialog = this._createDialog(body, [
                {
                    label: "Close",
                    click: function () {
                        errorDialog.close();
                    }
                }
            ]);
        }
    }

}
